<div class="product-selector-content">
    <!-- variant selection (leather, buckle, ...)-->
    @for (variant of product.variants | keyvalue; track variant.key;) { @if (variant.value !== undefined && variant.key
    !== 'sizes') {
    <ng-container
        [ngTemplateOutlet]="variantSelection"
        [ngTemplateOutletContext]="{
            variant: variant,
            variantType: getVariantType(variant.key)
        }"></ng-container>
    }}

    <!-- size selection -->
    <div class="selector size-selector">
        @if (product.variants?.sizes) {
        <h-option-selector
            [inputLabel]="product.beltkitAttributes?.sizeLabel"
            [inputValue]="'70'"
            (click)="handleSizeSelection()">
        </h-option-selector>
        @if (selectedProductVariant?.size?.size) {
        <span hSrOnlyNoSnippet>
            <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
            {{ selectedProductVariant?.size?.size }}
            <ng-container i18n="@@hermes.accessibility.page-product.selected"> selected </ng-container>
        </span>
        } }
        <div class="size-selector-footer">
            <div class="size-infos">
                <h-call-to-action-size-guide
                    [product]="product"
                    [buttonAlignClass]="'align-right'"
                    [isNewMeasureIconEnabled]="isProductRevampSelectorEnabled"
                    [hasMargin]="false">
                </h-call-to-action-size-guide>
                <div class="size-alert-text">
                    @if (hasMessageError()) {
                    <div class="size-alert-container">
                        <h-svg-icon name="exclamation"> </h-svg-icon>
                        <div
                            class="size-alert"
                            i18n="@@hermes-commerce-product-options-configurator.please-select-an-option">
                            Please choose a size
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<!-- A11Y Forms Error-->
@if (hasMessageError()) {
<span
    id="size-alert-message"
    hSrOnlyNoSnippet
    [attr.role]="'alert'"
    i18n="@@hermes-commerce-product-options-configurator.please-select-an-option">
    Please choose a size
</span>
}

<!-- Templates -->

<ng-template #variantSelection let-variant="variant" let-variantType="variantType">
    <div class="selector">
        <div class="selector-header paragraph-medium">
            <span class="title-light"> {{ variantType | translate }}</span>
            @if (getTemplateForVariantType(variantType).accessibilityTemplate) {
            <ng-container
                [ngTemplateOutlet]="
                    getTemplateForVariantType(variantType).accessibilityTemplate || null
                "></ng-container>
            }
            <ng-container [ngTemplateOutlet]="getTemplateForVariantType(variantType).template"></ng-container>
        </div>
        <h-product-variants
            [type]="variantType"
            [parentForm]="variantsForm"
            [variants]="getVariants(variantType)"
            [currentProduct]="product"
            [selectedValue]="getSelectedValue(variantType)"
            [moreVariantsEnabled]="true"
            [numberOfLinesToDisplay]="getNumberOfLinesToDisplay()"
            [isThinBorder]="true"
            [labelledById]="'toggle-title-' + variantType + '-variants'">
        </h-product-variants>
    </div>
</ng-template>

<!-- buckle header template  -->
<ng-template #buckle>
    <div class="selector-header-titles">
        @if (product.beltkitAttributes?.displayNameList) {
        <span>{{ product.beltkitAttributes?.displayNameList ?? "" | hSlashSpacer }}</span>
        }
        <span hSrOnlyNoSnippet>
            <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
            {{ product.beltkitAttributes?.colorHermesLabel }}
            <ng-container i18n="@@hermes.accessibility.colon">:&nbsp;</ng-container>
        </span>
        @if (product.beltkitAttributes?.colorHermesBuckle) {
        <span class="title-light">{{ product.beltkitAttributes?.colorHermesBuckle ?? "" | hSlashSpacer }}</span>
        }
        <span hSrOnlyNoSnippet>
            <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
        </span>
        <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.selected"> selected </span>
    </div>
</ng-template>

<ng-template #buckleAccessibility>
    <span hSrOnlyNoSnippet>
        <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
        {{ product.beltkitAttributes?.displayNameListLabel }}
        <ng-container i18n="@@hermes.accessibility.colon">:&nbsp;</ng-container>
    </span>
</ng-template>

<!-- leather header template  -->
<ng-template #leather>
    <span hSrOnlyNoSnippet>
        <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
    </span>
    {{ product.beltkitAttributes?.colorHermesLeather ?? "" | hSlashSpacer }}
    <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.selected"> selected </span>
</ng-template>

<!-- TODO others hearder templates ...  -->
